import { observer } from "mobx-react";
import * as React from "react";
import "./FreeFormCanvas.scss";
import {
    NodeCollectionStore,
    NodeStore,
    StaticTextNodeStore,
    VideoNodeStore,
    ImageNodeStore,
    WebNodeStore,
    StoreType,
    AudioNodeStore,
} from "../../stores";
import { panningMath } from "../../Utils";
import {
    TextNodeView,
    VideoNodeView,
    ImageNodeView,
    WebNodeView,
    AudioNodeView,
} from "../nodes";

import { NodeCollectionView } from "../nodes/NodeCollectionView/NodeCollectionView";
import { LinkLayer } from "../links/LinkLayer";

interface FreeFormProps {
    store: NodeCollectionStore;
}

/**
 * This class is the top level UI canvas for this project. It handles 
 * panning and rendering of nodes based on type.
 */
@observer
export class FreeFormCanvas extends React.Component<FreeFormProps> {
    private isPointerDown: boolean | undefined;

    onPointerDown = (event: React.PointerEvent): void => {
        if ((event.target as HTMLElement).closest(".node")) return;

        event.preventDefault();

        this.isPointerDown = true;

        document.addEventListener("pointermove", this.onPointerMove);
        document.addEventListener("pointerup", this.onPointerUp);
    };

    onPointerMove = (event: PointerEvent): void => {
        if (!this.isPointerDown) return;
        panningMath(this.props.store, event.movementX, event.movementY);
    };

    onPointerUp = (): void => {
        this.isPointerDown = false;
        document.removeEventListener("pointermove", this.onPointerMove);
        document.removeEventListener("pointerup", this.onPointerUp);
    };

    renderNode(nodeStore: NodeStore) {
        switch (nodeStore.type) {
            case StoreType.Text:
                return <TextNodeView key={nodeStore.Id} store={nodeStore as StaticTextNodeStore} />;

            case StoreType.Video:
                return <VideoNodeView key={nodeStore.Id} store={nodeStore as VideoNodeStore} />;

            case StoreType.Image:
                return <ImageNodeView key={nodeStore.Id} store={nodeStore as ImageNodeStore} />;

            case StoreType.Web:
                return <WebNodeView key={nodeStore.Id} store={nodeStore as WebNodeStore} />;

            case StoreType.Collection:
                return <NodeCollectionView key={nodeStore.Id} store={nodeStore as NodeCollectionStore} />;
            case StoreType.Audio:
                return <AudioNodeView key={nodeStore.Id} store={nodeStore as AudioNodeStore} />;

            default:
                return null;
        }
    }

    render() {
    const store = this.props.store;

    return (
        <div
        className="freeformcanvas-container"
        onPointerDown={this.onPointerDown}
        >      
        <LinkLayer root={store} />

        <div
        className="freeformcanvas"
        style={{ transform: store.transform }}
        >
        {store.nodes.map((node) => this.renderNode(node))}
        </div>
        </div>
        );
    }
}